/**
 * 
 * BodyWrapper.js
 * 
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap';



// components
import Home from './content/home/Home';
import About from './content/about/About';
import Problem from './content/problem/Problem';
import Solution from './content/solution/Solution';
import Demo from './content/demo/Demo';
import Footer from '../footer/Footer';


export default class BodyWrapper extends Component {

    static displayName = BodyWrapper.name;

    render() {
        return (
            <Container style={{ position: 'absolute', backgroundColor: '' }}>
                
                <Home />
                <About />
                <Problem />
                <Solution />
                <Demo />
                <Footer />
            </Container>
        );
    }


}


